import React from "react";
import { Link, useParams } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";
import { GoArrowUpRight } from "react-icons/go";
import Navbar from "../../component/Navbar/Navbar";
import Footer from "../../component/Footer/Footer";
import { getCategory } from "../../data/helpCenter";

const HelpCategory = () => {
  const { categorySlug } = useParams();
  const category = getCategory(categorySlug);

  if (!category) {
    return (
      <>
        <div className="bg-white p-4 max-w-screen-2xl mx-auto">
          <Navbar />
          <div className="min-h-[50vh] flex flex-col items-center justify-center gap-4 mt-20">
            <h1 className="font-jakarta font-bold text-2xl">Category not found</h1>
            <Link to="/help" className="text-[#3AB1F6] font-inter font-medium underline">
              Back to Help Center
            </Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <div className="bg-white p-4 max-w-screen-2xl mx-auto flex flex-col gap-10">
        <Navbar />

        <div className="flex flex-col gap-10 mt-28 md:mt-36 md:mx-[5%] mx-[2%]">
          {/* Breadcrumb */}
          <nav className="flex items-center gap-2 font-inter text-[0.95rem] text-[#00000099]">
            <Link to="/help" className="hover:text-[#3AB1F6] transition-colors">
              Help Center
            </Link>
            <FiChevronRight className="size-4" />
            <span className="text-black font-medium">{category.name}</span>
          </nav>

          {/* Header */}
          <div className="flex flex-col gap-3">
            <div className="flex items-center gap-3 flex-wrap">
              <h1 className="font-jakarta font-bold xl:text-[3rem] lg:text-[2.6rem] text-[2.2rem] leading-tight">
                {category.name}
              </h1>
              {category.badge && (
                <span className="text-[0.85rem] font-inter font-medium text-[#3AB1F6] bg-[#EBF7FE] px-3 py-1.5 rounded-full">
                  {category.badge}
                </span>
              )}
            </div>
            <p className="font-inter font-medium xl:text-[1.4rem] text-[1.15rem] text-[#00000099]">
              {category.summary}
            </p>
          </div>

          {/* Article list */}
          <div className="grid md:grid-cols-2 grid-cols-1 gap-4">
            {category.articles.map((article) => (
              <Link
                key={article.slug}
                to={`/help/topic/${category.slug}/${article.slug}`}
                className="group border border-[#0000001A] rounded-xl p-6 flex flex-col gap-2 hover:border-[#3AB1F6] hover:shadow-[0_8px_30px_rgba(58,177,246,0.12)] transition-all duration-300"
              >
                <div className="flex items-start justify-between gap-3">
                  <h2 className="font-inter font-semibold text-[1.25rem] leading-snug">
                    {article.title}
                  </h2>
                  <span className="flex-none text-[#3AB1F6] bg-[#EBF7FE] p-1.5 rounded-full group-hover:rotate-45 transition-transform duration-200">
                    <GoArrowUpRight className="size-4" />
                  </span>
                </div>
                <p className="font-inter text-[1rem] text-[#00000099] leading-relaxed">
                  {article.description}
                </p>
              </Link>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default HelpCategory;
